export const getters = {
  getQualifyStatus: state => state.qualifyStatus,
  getQualifyLoadingStatus: state => state.qualifyLoadingStatus,
};
